import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import {sortArrayByProperty} from '../../../helpers/array-helper';
import PieChart from 'components/ui/pie-chart/pie-chart';
import './result.scss';

const Result = ({languageId, type = 'facilitator', layout = null, resultId, deviceInfo, resultData}) => {

	const [currentResultId, setCurrentResultId] = useState(null);

	const pieChartValues = [];
	if (
		resultData.type === 'result' && 
		resultData && 
		resultData.result && 
		resultData.result.options
	) {
		const sortedResults = sortArrayByProperty(resultData.result.options, 'value', 'DESC');
		sortedResults.forEach((option) => {
			if (resultData.result.total > 0) {
				const percent = Math.round(100 * option.value / resultData.result.total);
				pieChartValues.push(percent);
			}
		});
	};
	
	useEffect(() => {
		/* Force piechart to re-animate */
		setCurrentResultId(resultId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resultId]);


	return (
		<div 
			className={'Result ' + deviceInfo.orientation + ' ' 
				+ resultData.type + ' ' + type + (layout ? ' ' + layout : '')}
		>
			{currentResultId === resultId && resultData.type === 'result' && <div className="Result-result pieChart">
				<div className="Result-pieChart">
					<PieChart type={type} deviceInfo={deviceInfo} values={pieChartValues} />
				</div>												
				<div className="Result-labels">
					{resultData.text && <div className="Result-text">
						{renderMarkdown(getText(resultData.text, languageId))}
					</div>}
					{type === 'stats' && <div className="Result-answers">
						<span>{resultData.result.total} {getText('general_answers', languageId)}</span>
					</div>}
					{resultData.result.options.map((option, index) => {
						return (
							<div 
								key={index} 
								className={'Result-label label-' + (index + 1)}
							>
								<span>
									{getText(option.text, languageId) + ' '} 
									({(pieChartValues[index] ? pieChartValues[index] : 0)}%)
								</span>
							</div>
						);
					})}
				</div>
			</div>}
		</div>
	);
};

Result.propTypes = {
	languageId: PropTypes.string.isRequired,
	type: PropTypes.string,
	layout: PropTypes.string,
	resultId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	resultData: PropTypes.object.isRequired
};

export default Result;
